module.exports = __webpack_public_path__ + "img/home1.507c6644.jpg";